import { Link } from "@mui/material";
import React from "react";
import styles from "../components/laymanComp_css/LaymanPage20.module.css";

export default function LaymanPage20() {
  return (
    <>
      <div className={styles.layman_block_2}>
        <div className={styles.block1_main_wrpr}>
          <div className={styles.block1_main_bg}>
            {/* <div className={styles.common_width_1}>
              <div className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle}`}>
                <div className={styles.column}>
                  <div className={`${styles.col12} ${styles.bgifive}`}>
                    <h1>VENERATION OF THE FULL MOON</h1>
                  </div>
                </div>
              </div>
            </div> */}
            <div className="common_leftright_pattern_titleblock">
                  <div className="common_leftright_pattern_titleblock_commonwidth">
                    <span className="common_leftright_pattern_titleblock_inner">
                      <div className="common_leftright_pattern_titleblock_header_wrapper">
                        <h1
                          className="common_leftright_pattern_titleblock_header"
                          
                        >VENERATION OF THE FULL MOON</h1>
                      </div>
                    </span>
                  </div>
                </div>

            <div className={styles.common_width}>
              <div className={styles.layman_yin_yang_block_main_wrpper}>
                <div className={`${styles.veneration_block1_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}>
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/LAYMAN_VENERATION_FULL_MOON/as_veneration_moon_block1_new_img.webp" /> */}
                    <img src={`${process.env.cloud_url}Layman-Symbolism/LAYMAN_VENERATION_FULL_MOON/as_veneration_moon_block1_new_img.webp`}/>
                  </div>
                  <div className={styles.layman_txt_box_wrpr}>
                    <div className={styles.layman_txt_box_innr}>
                      <div className={styles.layman_yellow_commn_header}>
                        <h2>
                          Illuminating the Shadows: The Veneration of the Full
                          Moon in Ancient Witchcraft
                        </h2>
                      </div>
                      <h3>Introduction:</h3>
                      <p>
                        Bathed in the ethereal glow of the night sky,{" "}
                        the full moon emerges as a mystical luminary, reflecting
                        the solar force and unveiling the tides of
                        consciousness. Across history, the veneration of the
                        full moon has transcended mere astronomical observation,
                        delving into the realms of ancient witchcraft and
                        mysticism. The Thessalian Witches, in particular,
                        harnessed the potent energies of the full moon to
                        empower vegetation and weave enchantments through
                        magical spells and talismans. In this article, we embark
                        on a journey through time, uncovering the historical
                        significance of full moon veneration and exploring the
                        profound ideas that link lunar energies to the awakening
                        of psychic abilities, divination, and a heightened
                        awareness of the Imaginal realm of the soul.
                      </p>
                      <h3>Lunar Energies and Mystical Transformation:</h3>

                      <p>
                        The full moon, with its luminous presence, possesses the
                        enchanting power to transform the ordinary into the
                        mystic. Ancient practitioners drew down the moon's
                        energies, invoking the lunar forces to infuse life into
                        the Earth and stimulate magical endeavors. It is the
                        interplay of solar and lunar energies that opens the
                        gateway to the mystical, inviting us to partake in the
                        alchemical dance between light and shadow.
                      </p>
                    </div>
                  </div>
                </div>

                <div className={`${styles.veneration_block2_wrpr} ${styles.flex} ${styles.cmmn_mrgn} `}>
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/LAYMAN_VENERATION_FULL_MOON/as_veneration_moon_block2_img.webp" /> */}
                    <img src={`${process.env.cloud_url}Layman-Symbolism/LAYMAN_VENERATION_FULL_MOON/as_veneration_moon_block2_img.webp`}/>
                  </div>

                  <div className={styles.layman_txt_box_wrpr}>
                    <div className={styles.layman_txt_box_innr}>
                      <h3>Psychic Abilities and Intuitive Receptivity:</h3>
                      <p>
                        Under the radiant influence of the full moon, our
                        consciousness is awakened to natural psychic abilities.
                        From pre-cognition and divination to remote viewing,
                        {" "}
                        the lunar energies bestow upon us a heightened
                        sensitivity to the unseen. The moon, reflecting our
                        inner sun, becomes a catalyst for delving into the
                        Higher Unconscious, unraveling the depths of our
                        becoming through intuitive receptivity. This lunar
                        communion unveils the profound connections between the
                        moon and the unfathomable realms of the Imaginal— a space
                        where the soul's narrative unfolds.
                      </p>

                      <h3>Embracing the Mythical World:</h3>

                      <p>
                        In the act of drawing down the moon, we invoke the
                        spirit of Demeter, the Lunar Huntress, and open
                        ourselves to the mythical world of our personal
                        narrative. Veneration is given to Hecate, the maiden
                        dancing through the realm of fairies and nymphs. The
                        allure of moonlight becomes a channel to ecstasy, as we
                        surrender to the primitive impulses inherent in our
                        nature. The full moon, in its radiant fullness, invites
                        us to embrace the youthful feminine force with its
                        inherent dangers and delights— a dance with the
                        ever-present allure of the lunar energies.
                      </p>

                      <h3>Conclusion:</h3>

                      <p>
                        The veneration of the full moon, rooted in ancient
                        witchcraft, transcends time and culture, weaving a
                        narrative of mystery and magic. From the Thessalian
                        Witches drawing down lunar energies to empower nature to
                        our contemporary exploration of psychic abilities and
                        the Imaginal realm, the full moon remains a cosmic
                        bridge between the seen and the unseen. As we gaze upon
                        its radiant countenance, we are reminded of the eternal
                        dance between light and shadow, between the known and
                        the mystical, and the profound allure of the moon's
                        enduring influence on the human soul.
                      </p>
                    </div>
                  </div>
                </div>

                <div className={`${styles.veneration_block3_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}>
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/LAYMAN_VENERATION_FULL_MOON/as_veneration_moon_block3_img.webp" /> */}
                    <img src={`${process.env.cloud_url}Layman-Symbolism/LAYMAN_VENERATION_FULL_MOON/as_veneration_moon_block3_img.webp`}/>
                  </div>
                  <div className={styles.layman_txt_box_wrpr}>
                    <div
                      className={`${styles.layman_txt_box_innr} ${styles.bullet_wrapper}`}
                    >
                      <div className={styles.layman_yellow_commn_header}>
                        <h2>Astrological Features:</h2>
                      </div>

                      <p>
                        <strong>Full Moon Phases:</strong> The veneration of the
                        full moon is intricately tied to specific lunar phases,
                        particularly when the moon reaches its fullest
                        illumination in the night sky.
                      </p>
                      <p>
                        <strong>Lunar Cycles:</strong> Practitioners often
                        consider the cyclical nature of the moon, recognizing
                        its waxing and waning phases.{" "}
                        The full moon marks a peak in its cycle,{" "}
                        symbolizing culmination and completeness.
                      </p>
                      <p>
                        <strong>Zodiacal Sign:</strong> Astrologically, the
                        position of the full moon within a zodiacal sign is
                        crucial. Different signs may influence the energies and
                        themes associated with the full moon, adding depth to
                        the veneration rituals.
                      </p>

                      <p>
                        <strong>Opposition Aspect:</strong> The full moon occurs
                        when the sun and moon are in opposition, creating an
                        astrological aspect that emphasizes balance and
                        illumination. This opposition highlights the contrast
                        between the conscious{" "} (sun) and
                        unconscious (moon) aspects of the self.
                      </p>

                      <p>
                        <strong>Astrological Houses:</strong> Depending on the
                        zodiacal sign in which the full moon occurs, its
                        influence can vary across different astrological houses,
                        shaping the areas of life that may be illuminated or
                        brought to fruition.
                      </p>

                      <p>
                        <strong>Planetary Aspects:</strong> Consideration of
                        planetary aspects to the full moon adds layers of
                        meaning to veneration practices. For example, a full
                        moon in conjunction with a particular planet may
                        intensify or modify its energies.
                      </p>
                    </div>
                  </div>
                </div>

                <div className={`${styles.veneration_block4_wrpr} ${styles.flex} ${styles.cmmn_mrgn} `}>
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/LAYMAN_VENERATION_FULL_MOON/as_veneration_moon_block4_img.webp" /> */}
                    <img src={`${process.env.cloud_url}Layman-Symbolism/LAYMAN_VENERATION_FULL_MOON/as_veneration_moon_block4_img.webp`}/>
                  </div>

                  <div className={styles.layman_txt_box_wrpr}>
                    <div
                      className={`${styles.layman_txt_box_innr} ${styles.bullet_wrapper}`}
                    >
                      <p>
                        <strong>clipses:</strong> In some cases, a full moon may
                        coincide with a lunar eclipse, adding a potent
                        astrological dimension. Eclipses amplify the
                        transformative and shadowy aspects associated with the
                        veneration of the full moon.
                      </p>
                      <p>
                        <strong>Personal Natal Chart:</strong> Individuals often
                        explore their personal natal charts to understand how
                        the full moon aligns with their unique astrological
                        configurations. This personalized approach allows for a
                        more tailored and meaningful veneration practice.
                      </p>

                      <p>
                        <strong>Fixed Stars:</strong> Astrologers may also take
                        into account the influence of fixed stars in proximity
                        to the New Moon, as their positions can contribute
                        symbolic meanings or amplify certain energies.
                      </p>

                      <p>
                        <strong>Lunar Mansions:</strong> Some practitioners of
                        astrology may consider the lunar mansions or Nakshatras,
                          which are divisions of the moon's orbit
                        , adding further nuance to the interpretation of the
                        full moon's energies.
                      </p>

                      <p>
                        <strong>Retrograde Planets:</strong> If any planets are
                        in retrograde during the full moon, it can influence the
                        overall astrological atmosphere. Retrograde motion often
                        signifies introspection and revisiting past experiences.
                      </p>

                      <p>
                        <strong>Aspect Patterns:</strong> Analyzing aspect
                        patterns involving the full moon, such as grand trines,
                        T-squares, or yods, provides insight into the broader
                        dynamics at play during the veneration.
                      </p>

                      <p>
                        <strong>Lunar Nodes:</strong> The position of the lunar
                        nodes{" "} (North Node and South Node){" "}
                        during the full moon offers information about the karmic
                        aspects and life path influences associated with this
                        phase.
                      </p>
                    </div>
                  </div>
                </div>

                <div className={`${styles.veneration_block5_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}>
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/LAYMAN_VENERATION_FULL_MOON/as_veneration_moon_block5_img.webp" /> */}
                    <img src={`${process.env.cloud_url}Layman-Symbolism/LAYMAN_VENERATION_FULL_MOON/as_veneration_moon_block5_img.webp`}/>
                  </div>
                  <div className={styles.layman_txt_box_wrpr}>
                    <div
                      className={`${styles.layman_txt_box_innr} ${styles.bullet_wrapper}`}
                    >
                      <p>
                        <strong>Transits:</strong> Observing the transits of
                        other planets to the full moon in the natal chart or by
                        progression adds layers of astrological significance,
                        indicating potential areas of focus or challenge.
                      </p>
                      <p>
                        <strong>Fixed Stars:</strong> Some astrologers consider
                        the influence of fixed stars during the full moon, as
                        their positions relative to the moon can contribute
                        symbolic meanings or amplify certain energies.
                      </p>
                      <p>
                        <strong>Sabian Symbols:</strong> The Sabian Symbols
                        associated with the specific degree of the full moon in
                        a zodiac sign provide symbolic images that can deepen
                        the understanding of its astrological implications.
                      </p>
                      <p>
                        <strong>Solar-Lunar Relationship:</strong> Considering
                        the relationship between the current full moon and the
                        recent or upcoming solar eclipse, if any, can shed light
                        on broader themes of transformation and evolution.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`${styles.green_sec_cmn_main_wrp} ${styles.veneration_green_wrapper}`}>
            <div className={styles.common_width}>
              <Link href="/rota-the-wheel">
                <div className={styles.green_sec_cmn_sub_wrp}>
                  <h1>
                    The Astrological Tarot association for the Full Moon is{" "}
                    <br /> The High Priestess. See our alchemical ROTA here
                  </h1>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>

        {/* <div className={styles.demo_image}>
              <div className={styles.block1_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_full_moon/layman_page20_block1_demo_img.webp'></img>
              </div>

              <div className={styles.block2_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_full_moon/layman_page20_block2_demo_img.webp'></img>
              </div>

              <div className={styles.block3_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_full_moon/layman_page20_block3_demo_img.webp'></img>
              </div>

              <div className={styles.block4_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_full_moon/layman_page20_block4_demo_img.webp'></img>
              </div>

              <div className={styles.block5_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_full_moon/layman_page20_block5_demo_img.webp'></img>
              </div>

              <div className={styles.block6_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_full_moon/layman_page20_block6_demo_img.webp'></img>
                <Link className={styles.blank_link} href="/rota-the-wheel"></Link>
              </div>
            </div> */}
    </>
  );
}
